import React, {useEffect, useState} from 'react';
import QRCode from 'react-qr-code';
import {useDispatch} from "react-redux";
import {useNavigate, useParams} from "react-router-dom";
import OrderTags from "../OrderTags";
import {Button} from "@mui/material";
import { useTranslation } from "react-i18next";

interface OrderMainDetailsProps {
    selectedOrder: any;
}

const OrderMainAcceptedDetails = (props: OrderMainDetailsProps) => {
    const { t } = useTranslation();
    const {category, details, order} = useParams();
    //const [selectedProduct, setSelectedProduct] = useState<any>();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // 137

        /*
        *                     localStorage.removeItem("acceptedDineInReservationId");
                    localStorage.removeItem("acceptedOrder");
                    localStorage.removeItem("selectedUserInfo");
        * */
    }

    useEffect(() => {
        scrollToTop();
        console.log("props.selectedOrder: ", props.selectedOrder);

        const fetchData = async () => {
            try {
                console.log("details: ", details); // meal id

                if (props.selectedOrder) {
                    //setSelectedProduct(props.selectedOrder);
                }

                /*const response = await getData(dispatch);
                if (response) {
                    response.forEach((item: any) => {
                        item.data.forEach((i: any) => {
                            if (i.name.toLowerCase().replace(/\s/g, "-") === details ? details : "") {
                                console.log("Selected product: ", i);
                                setSelectedProduct(i);
                                // localStorage.setItem("selectedCategory", JSON.stringify(item.category));
                            }
                        });
                    });
                }*/
            }
            catch (error) {
                console.log(error);
            }
        }
        fetchData().then();
    }, [dispatch, category, details]);

    return (
        <>
            {
                props.selectedOrder && (
                    <div className="orderMainDetails__container-wrap">
                        <div className="orderMainDetails__container">
                            <div className="orderMainDetails__container-card">
                                <div className="orderMainDetails__container-card-wrap">
                                    <div className="orderMainDetails__container-card-image-wrap">
                                        <div className="orderMainDetails__container-card-image">
                                            <div className="orderMainDetails__container-data-reservation-wrap">
                                                <div className="orderMainDetails__container-data-reservation">
                                                    <span>{props.selectedOrder.isDineIn ? t('const.dineIn') : t('const.takeOut')}</span>
                                                </div>
                                            </div>
                                            <img
                                                src={props.selectedOrder.isDineIn ? props.selectedOrder.reservation.restaurantId.images[0] : props.selectedOrder.reservation.takeOutAdId?.image}
                                                alt='card image'
                                            />
                                        </div>
                                    </div>
                                    <div className="orderMainDetails__container-card-name-wrap">
                                        <div className="orderMainDetails__container-card-name">
                                            <span>{
                                                props.selectedOrder.isDineIn ?
                                                  t(`const.${props.selectedOrder.reservation.dineInAdId.onOption.toLowerCase()}`)
                                                  :
                                                  props.selectedOrder.reservation.takeOutAdId?.name
                                            }</span>
                                        </div>
                                        {
                                            props.selectedOrder.isDineIn ? (
                                              <div className="orderMainDetails__container-card-price-wrap">
                                                  <div className="orderMainDetails__container-card-discount">
                                                      <span>{props.selectedOrder.reservation.dineInAdId.discount}% {t('const.discount')}</span>
                                                  </div>
                                              </div>
                                            ) : (
                                              <div className="orderMainDetails__container-card-price-wrap">
                                                  <div className="orderMainDetails__container-card-price">
                                                      <span>€{props.selectedOrder.reservation.takeOutAdId.priceBefore}</span>
                                                  </div>
                                                  <div className="orderMainDetails__container-card-discount">
                                                      <span>€{props.selectedOrder.reservation.takeOutAdId.priceNow}</span>
                                                  </div>
                                              </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className="orderMainDetails__container-description pay">
                                <div className="orderMainDetails__container-description-wrap">
                                    <div className="orderMainDetails__container-qr-wrap">
                                        <div className="orderMainDetails__container-description-time-wrap pay">
                                            <div className="orderMainDetails__container-description-title-wrap pay">
                                                <div className="orderMainDetails__container-description-title payment">
                                                    <img src={`${process.env.PUBLIC_URL}/images/done-icon.png`} alt="done" />
                                                    <span>{props.selectedOrder.isDineIn ? t('cart.reservationSuccess') : t('cart.paymentSuccess')}</span>
                                                </div>
                                            </div>
                                            <div className="orderMainDetails__container-description-title-wrap pay">
                                                <div className="orderMainDetails__container-description-title">
                                                    <span>{props.selectedOrder.isDineIn ? props.selectedOrder.reservation.restaurantId.name : category}</span>
                                                </div>
                                                <div className="orderMainDetails__container-description-place">
                                                    <span>{props.selectedOrder.reservation.restaurantId.address?.name}</span>
                                                </div>
                                            </div>
                                            <div className="orderMainDetails__container-description-dine-in-wrap">
                                                <div className="orderMainDetails__container-description-dine-in-wrap-image">
                                                    <img
                                                      src={`${process.env.PUBLIC_URL}/images/dine-in-icon.svg`}
                                                      alt='dine-in-icon'
                                                    />
                                                </div>
                                                <div className="orderMainDetails__container-description-dine-in">
                                                    <span>{props.selectedOrder.isDineIn ? `${props.selectedOrder.reservation.guestsNr} ${t('const.guests')}` : `${props.selectedOrder.reservation.mealsNr} ${t('const.meals')}`}</span>
                                                </div>
                                            </div>
                                            <div className="orderMainDetails__container-description-timer-wrap">
                                                <div className="orderMainDetails__container-description-timer-wrap-image">
                                                    <img
                                                      src={`${process.env.PUBLIC_URL}/images/timer-icon.svg`}
                                                      alt='timer-icon'
                                                    />
                                                </div>
                                                <div className="orderMainDetails__container-description-timer">
                                                    <span>{props.selectedOrder.reservation.reservationTime}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="orderMainDetails__container-qr">
                                            <QRCode
                                              value={`${details}`}
                                              size={200}
                                            />
                                        </div>

                                    </div>

                                    <div className="orderMainDetails__container-description-main-wrap pay">
                                        <div className="orderMainDetails__container-description-content-discount-wrap pay">
                                            <span>{t('cart.weSendQRCodeToEmail')}</span>
                                        </div>

                                        <div className="orderMainDetails__container-description-content-wrap pay">
                                            <span>{t('cart.canFindInMyCodes')}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="orderMainDetails__container-buttons-wrap pay">
                                    <Button
                                      className="orderButtons__container-button-btn dine-in"
                                      variant="contained"
                                      onClick={() => navigate('/my-codes')}
                                    >
                                            <span>{t('buttons.goToMyCodes')}</span>
                                    </Button>
                                    <Button
                                      className="orderButtons__container-button-btn dine-in"
                                      variant="contained"
                                      onClick={() => navigate('/food')}
                                    >
                                        <span>{t('buttons.findMore')}</span>
                                    </Button>
                                    {/*<OrderButtons
                                        acceptOrderHandle={acceptOrderHandler}
                                        selectedOrder={selectedProduct}
                                        acceptTimeHandle={acceptTimeHandler}
                                        isDineIn={selectedProduct.isDineIn}
                                    />*/}
                                </div>

                                {/*<div className="orderMainDetails__container-tags-wrap not-adaptive">
                                    <OrderTags tags={selectedProduct.isDineIn ? selectedProduct.category : selectedProduct.data.tags}/>
                                </div>*/}
                            </div>
                        </div>
                        <div className="orderMainDetails__container-tags-wrap adaptive">
                            <OrderTags tags={props.selectedOrder.isDineIn ? props.selectedOrder.reservation.restaurantId.tags : props.selectedOrder.reservation.takeOutAdId.tags}/>
                        </div>
                    </div>
                )
            }
        </>
    );
};

export default OrderMainAcceptedDetails;